import { gql } from "@apollo/client";

export const SUBSCRIBE_V2_CONNECTED_STATE = gql`
  subscription newV2ConnectedState {
    newV2ConnectedState {
      connected
      connectionType
      retrying
      directConnectionParams {
        host
        port
        username
        password
      }
      activeReceiver
      connectedReceivers
      analytics {
        connectedTime
        totalMessages
        resetTime
      }
    }
  }
`;

export const QUERY_V2_CONNECTED_STATE = gql`
  query getV2ConnectedState {
    getV2ConnectedState {
      connected
      connectionType
      retrying
      directConnectionParams {
        host
        port
        username
        password
      }
      activeReceiver
      connectedReceivers
      analytics {
        connectedTime
        totalMessages
        resetTime
      }
    }
  }
`;

export const QUERY_V2_PROTOCOL_DATA = gql`
  query getV2ProtocolData {
    getV2ProtocolData {
      timing
      weather
      raceControl
      FiaFormulaE
      signalling
      rgps
    }
  }
`;

export const SUBSCRIBE_V2_PROTOCOL_DATA = gql`
  subscription newV2ProtocolData {
    newV2ProtocolData {
      timing
      weather
      raceControl
      FiaFormulaE
      signalling
      rgps
    }
  }
`;

export const MUTATE_CONNECT_V2_PROTOCOL = gql`
  mutation connectToV2Protocol($params: V2ConnectionParamsInput!) {
    connectToV2Protocol(params: $params)
  }
`;

export const MUTATE_DISCONNECT_V2_PROTOCOL = gql`
  mutation disconnectFromV2Protocol {
    disconnectFromV2Protocol
  }
`;

export const MUTATE_CONNECT_TO_V2_PROTOCOL_RECEIVER = gql`
  mutation connectToV2ProtocolReceiver($receiverName: String!) {
    connectToV2ProtocolReceiver(receiverName: $receiverName)
  }
`;

export const MUTATE_DISCONNECT_FROM_V2_PROTOCOL_RECEIVER = gql`
  mutation disconnectFromV2ProtocolReceiver {
    disconnectFromV2ProtocolReceiver
  }
`;

export const MUTATE_SET_V2_MODE = gql`
  mutation setV2Mode($mode: String!) {
    setV2Mode(mode: $mode)
  }
`;
